import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'


export const fetchLosDetails = createAsyncThunk(
  'fetchLosDetails',
  async ({ jwtBearer,application_id }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}master/s3/bindparams/?application_id=${application_id}`, {
        headers: {
          Authorization: `Bearer ${jwtBearer}`,
        },
      });

      const responseData = await response.json();

      if (!response.ok) {
        return rejectWithValue(responseData);
      }

      return responseData;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.reload();
      }
      console.error('Fetch error:', error);
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);


const adminSlice = createSlice({
  name: 'losDetails',
  initialState: {
    isLoading: false,
    data: null,
    isError: false
  },
  extraReducers: builder => {
    builder.addCase(fetchLosDetails.pending, (state, action) => {
      state.isLoading = true
    })
    builder.addCase(fetchLosDetails.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
      console.log("state.data: ",state.data)
    })
    builder.addCase(fetchLosDetails.rejected, (state, action) => {
      console.log('Error', action.payload)
      state.isError = true
    })
  }
})

export default adminSlice.reducer
